/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { v4 as uuidv4 } from "uuid";
import { QUICK_SEARCH_QUERY } from "../api/queries";
import { productSearch, getGenderFilter } from "../api/request";

const topSearchRequest = {
    /**
     * get live search products
     *
     * @returns {Promise<*|*[]>}
     */
    async getTopSearchProducts() {
        try {
            this.searchRequestId = uuidv4();

            this.handleContextInput();

            const before = Date.now();

            // Build search parameters with current filters and settings
            const searchParams = {
                phrase: this.queryPhrase,
                pageSize: this.topSearchPageSize,
                currentPage: 1,
                filter: [
                    { attribute: "visibility", in: ["Catalog, Search"] },
                    { attribute: "inStock", eq: "true" },
                    { attribute: "department", eq: getGenderFilter() }
                ]
            };

            const result = await productSearch(this.apiUrl, QUICK_SEARCH_QUERY, searchParams, (error) => {});

            const after = Date.now();

            this.handleContextResults(result, before, after);

            return result;
        } catch (error) {
            console.error("getTopSearchProducts error:", error);
        }
    },
    /**
     * get products
     *
     * @returns {Promise<void>}
     */
    async getProducts() {
        try {
            const result = await this.getTopSearchProducts();

            this.liveSearchProducts = this.formatProductItems(result.productSearch.items);
            this.liveSearchSuggestions = result.productSearch.suggestions;
            this.liveSearchCategories = this.getCategories(result.productSearch.facets);

            this.dataLayerPushData(this.liveSearchProducts, this.liveSearchSuggestions, this.queryPhrase);
        } catch (error) {
            console.error("getProducts error:", error);
        }
    },
}

export default topSearchRequest;
